// Google Consent Mode v2 + dataLayer events bound to the cookie categories
// The default state (all denied) is pushed by templates/_partials/consent-mode.tpl
import prestashop from 'prestashop';
import { DataLayer } from '@/services/datalayer';
import { capitalize, TCookieAgreement, TCookies } from './categories';

type TConsentValue = 'granted' | 'denied';
type TConsent = { [type: string]: TConsentValue };

// Cookie category => Consent Mode storage types
const consentModeMap: { [category: string]: string[] } = {
    analytics: ['analytics_storage'],
    advertising: ['ad_storage', 'ad_user_data', 'ad_personalization'],
    personalization: ['personalization_storage'],
};

// gtag() expects an Arguments object, not an array
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function gtag(..._args: unknown[]) {
    window.dataLayer = window.dataLayer || [];
    // eslint-disable-next-line prefer-rest-params
    window.dataLayer.push(arguments);
}

const toConsent = (category: string, enabled: boolean) => {
    const consent: TConsent = {};

    (consentModeMap[category] || []).forEach((type) => {
        consent[type] = enabled ? 'granted' : 'denied';
    });

    return consent;
};

const toEvent = (category: string, enabled: boolean) =>
    `gdpr${enabled ? 'Allow' : 'Disallow'}${capitalize(category)}`;

export function bindConsentMode() {
    DataLayer.init();

    prestashop.on('gdprUpdate', ({ key, value }: TCookieAgreement) => {
        const consent = toConsent(key, value);

        if (Object.keys(consent).length) {
            gtag('consent', 'update', consent);
        }

        DataLayer.push({ event: toEvent(key, value) });
    });

    prestashop.on('gdprInit', (agreements: TCookies) => {
        const gdprData: { [key: string]: boolean } = {};
        let consent: TConsent = {};

        for (const [category, [, enabled]] of Object.entries(agreements)) {
            gdprData[`gdpr${capitalize(category)}`] = enabled;
            consent = { ...consent, ...toConsent(category, enabled) };
        }

        DataLayer.push(gdprData);

        for (const [category, [, enabled]] of Object.entries(agreements)) {
            DataLayer.push({ event: toEvent(category, enabled) });
        }

        gtag('consent', 'update', consent);

        DataLayer.push({ event: 'gdprInitialized' });
    });
}
